export enum userRole {
  staff = 'Staff',
  admin = 'Admin',
}

export enum DynamicTypes {
  boolean = 'bool',
  string = 'string',
  number = 'number',
  enum = 'enum',
}
